import CustomTable from "@UI/CustomTable/CustomTable"
import HistoryCollectionHeader from "./components/HistoryCollectionHeader/HistoryCollectionHeader"
import { useCollectionHistoryTable } from "./hooks/useCollectionHistoryTable"
import './styles.css'
import { COLLECTION_ADMINISTRATION_CODES, COLLECTION_ADMINISTRATION_CODES_NAMES } from "@constants/modules/collectionAdministration/collectionAdministrationCodes"
import { useFeatureRole } from "@thooks/useFeatureRole"
import { CustomSpin } from "@UI/CustomSpin"

const HistoryCollectionPage = () => {

  const {
    loadingCollectionHistoryTable,
    collectionHistoryTable,
    handleChangeTable,
    columns
  } = useCollectionHistoryTable()

  const { loadingFeatures } = useFeatureRole({
    feature_codes: COLLECTION_ADMINISTRATION_CODES,
    validate_code: COLLECTION_ADMINISTRATION_CODES_NAMES.COLLECTION_ADMINISTRATION_PAYMENTS_HISTORY,
    returnUrl: '/administration-collection',
  })

  if (loadingFeatures) return <CustomSpin tip="Cargando módulo" />
  return (
    <section className="section-wrapper">
      <HistoryCollectionHeader />
      <CustomTable
        className="custom-table-variant-1"
        loading={loadingCollectionHistoryTable}
        rowKey={'id'}
        columns={columns}
        dataSource={collectionHistoryTable.dataTable}
        onChange={handleChangeTable}
        pagination={{
          pageSize: collectionHistoryTable.metadata.limit,
          total: collectionHistoryTable.metadata.quantity,
          defaulPageSize: collectionHistoryTable.metadata.limit,
          current: collectionHistoryTable.currentPage,
          showTotal: (total, range) => `${range[0]}-${range[1]} de ${total}`,
          position: ["bottomRight"]
        }}
      />
    </section>
  )
}

export default HistoryCollectionPage
